import React from 'react';
import { Box, Fab } from '@mui/material';

import linkIcon from '../../../images/icons/link.svg';

export const SiteButton = ({ url }) => {
  const { hostname } = new URL(url);

  const handleClick = () => window.open(url, '_blank');

  return (
  <Fab variant="extended" size="small" color="secondary" onClick={handleClick}>
    <Box mr={0.5} mb={-1}>
      <img src={linkIcon} alt='icon' style={{width: '20px'}}/>
    </Box>
    {hostname}
  </Fab>
  )
};